<template>
  <div class="drugSearchComponent">
    <div class="flex drug_select_block">
      <div class="maxWidth">
        <v-select ref="select" v-model="drug" @keypress.enter.native.prevent="" label="title" placeholder="Препарат"
                  :filterable="false"
                  @input="selectDrug"
                  @keypress.native="fastSearchCheck"
                  :options="drugList"
                  @search="searchDrug">
          <template slot="no-options">
            введите название препарата..
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <template v-if="option && option.title">
                {{ option && option.title || '' }}
                {{ showDetails !== false && option.veshchestvo ? '::' + option.veshchestvo : '' }}
              </template>
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <template v-if="option && option.title">
              {{ option.title || '' }}
              {{ showDetails !== false && option.veshchestvo ? ':: ' + option.veshchestvo : '' }}
              {{ showId && option.id ? '(' + option.id + ')' : '' }}
            </template>
          </template>
        </v-select>
      </div>
      <div v-if="enableQty" class="flex">
        <div class="wd-70" v-if="drug">
          <input @change="updateDrug"
                 v-model="drug.qty"
                 placeholder="Количество"
                 type="number"
                 class="form-control border-r-0  h-100"
                 name="qty"
          >
        </div>
        <div v-if="drug && drug.holod" class="cool_mark"><i class="icon icon-snowflake"/></div>
        <div v-if="drug">
          <v-popover :auto-hide="true">
            <button @click="getDrugInfo(drug.id, true)" style="height: 38px"
                    class="btn btn-info btn-xs border-r-0 sm-btn"><i class="icon-fa icon-fa-info icon-info"></i>
            </button>
            <template slot="popover">
              <template v-if="localDrugData && localDrugData.info">
                <div v-html="printDrugInfo(localDrugData.info)"></div>
              </template>
              <template v-else>
                Загрузка ....
              </template>
              <button v-close-popover class="btn btn-theme btn-sm">Закрыть</button>
            </template>
          </v-popover>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import vSelect from 'vue-select';
import VTooltip from 'v-tooltip'
import api from '@/api'

export default {
  components: {
    vSelect,
    VTooltip,
  },
  props: [
    'drugSelected', 'detailedSearch', 'enableQty', 'getPrice', 'updateDrug', 'alreadySelectedCheck',
    'showId', 'onDrugSelect', 'showDetails', 'url'
  ],
  data() {
    return {
      drugInfoLoading: false,
      localDrugData: null,
      drug: null,
      drugList: [],
    }
  },
  mounted() {
    if (this.drugSelected) {
      if (this.drugSelected.prep && !this.drugSelected.title) {
        this.drugSelected.title = this.drugSelected.prep;
      }
      this.drug = this.drugSelected;
    }
  },
  methods: {
    fastSearchCheck(e) {
      // console.log(e);
      // if ()
      // console.log(this.$refs.select.search);
      // selectDrug()
    },
    selectDrug(e) {
      console.log('selected', e);
      if (e) {
        e.qty = 1;
        if (this.alreadySelectedCheck) {
          if (this.alreadySelectedCheck(e)) {
            this.drug = null;
            toastr['warning']('Такой препарат уже выбран');
          }
        }
      }
      this.localDrugData = null;
      if (this.updateDrug) {
        this.updateDrug();
      }
      if (this.onDrugSelect) {
        this.onDrugSelect(this.drug);
      }
    },
    searchDrug(search, loading) {
      if (!search || search.length < 3) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      fetch(
        `/api/noa/getDrugByName?search=${encodeURIComponent(search)}&` + (vm.getPrice ? 'getPrice=1&siteId=' + vm.getPrice.siteId : 'options=drugOnly')
      ).then(res => {
        res.json().then((json) => {
          vm.drugList = [];
          if (vm.detailedSearch) {
            vm.drugList.push({title: search, veshchestvo: 'все совпадения'})
          }
          vm.drugList = [...vm.drugList, ...json.items];
        });
        loading(false);
      });
    }, 1),
    async getDrugInfo(id, update = false) {
      if (!id) return;
      if (!update) this.drugInfoLoading = true;
      if (this.localDrugData && this.localDrugData.name) return;

      let {data} = await api.post('/drugs/getInfoBySite', {site: 1, drug: id, update: update});

      if (!this.localDrugData) this.localDrugData = {};
      if (data.success) {
        this.localDrugData.info = data.drugInfo.info;
      } else {
        this.localDrugData[id][this.order.site] = {error: data.message};
      }
      if (!update) this.drugInfoLoading = false;
    },
    printDrugInfo(data) {
      if (data.error) {
        return '<p class="color-red">' + data.error + '</p>';
      }
      let text = '<div class="tooltipBlock"><div><img src="' + data.image_link + '" alt=""></div><div>';
      text += '<p>Препарат <a href="' + data.link + '" target="_blank">' + data.name + '</a></p>';
      data.options.forEach((opt) => {
        text += '<p>' + opt.title + ': <strong>' + opt.value + '</strong></p>';
      });
      text += '</div></div>';
      return text;

    },
  }
}

</script>

<style scoped>
@media (max-width: 520px) {
  .drug_select_block {
    flex-direction: column;
  }
}

.drugSearchComponent {
  min-width: 250px;
}

.icon-info {
  text-align: center;
}

.sm-btn {
  height: 34px !important;
}

.v-select {
  font-size: 16px;
}

.wd-70 {
  width: 70px;
}

.maxWidth {
  width: 100%;
  /*min-width: 450px;*/
  /*width: 70%;*/
  text-align: left;
}
</style>

<style>
.vs--single .vs__selected {
  max-width: 90%;
}

.vs__dropdown-toggle {
  border-radius: 0;
  /*height: 35px;*/
}

.tooltip {
  //z-index: 990000 !important;
}

.tooltip-inner {
  background: white !important;
  color: #333 !important;
  max-width: max-content !important;
}

.drugSearchComponent .popover a {
  color: #007dcc;
}

.drugSearchComponent .popover {
  max-width: max-content !important;
}

.drugSearchComponent .vs__dropdown-toggle {
  height: auto !important;
  max-height: 117px;
  min-height: 38px;
  border-radius: 0;
}

.tooltip-inner p {
  text-align: left;
}

.tooltipBlock p {
  margin-bottom: 2px;
}

</style>
